<template>
  <LegacyPageContent v-if="hasProfile">
    <Greetings
      :title="`Hi ${profile ? profile.given_name : ''}`"
    />
    <v-alert
      v-if="(profile && (profile.available === undefined || profile.nextAvailabilityNotificationAt < now))"
      dismissible
      close-icon="$close"
      prominent
      text
      @input="nextAvailabilityNotification"
    >
      <div class="subtitle-1">
        You have not updated your availability for the last 7 days.
      </div>
      <br>
      <div class="caption-1">
        Please update your availability to increase your chances of getting a project from clients.
      </div>
      <br>
      <div>
        <WeeklyAvailability
          title="Update Availability"
          color="black"
        />
      </div>
    </v-alert>

    <v-row no-gutters>
      <v-col>
        Here is an overview of your latest activity:
      </v-col>
    </v-row>

    <v-row>
      <Notifications />
    </v-row>

    <v-row>
      <v-col>
        <SectionPanels
          :profile-percent="profilePercent"
          :opportunities="allTotal"
          :connections="connectionsTotal"
          :rewards="section.rewards"
        />
      </v-col>
    </v-row>
    <!-- <PostOpportunityCampaignDialog /> -->
  </LegacyPageContent>
</template>

<script lang="ts">
import { mapGetters } from 'vuex'
import { Component, Prop, Vue } from 'vue-property-decorator'

import Notifications from '@/components/dashboard/Notifications.vue'
import Greetings from '@/components/core/Greetings.vue'
import SectionPanels from '@/components/dashboard/SectionPanels.vue'
import LegacyPageContent from '@/components/layouts/LegacyPageContent.vue'
// import PostOpportunityCampaignDialog from '@/components/campaigns/PostOpportunityCampaignDialog.vue'
import { IUser } from '@/types/models/user.model'
import WeeklyAvailability from '@/components/core/WeeklyAvailability.vue'

@Component({
  components: {
    Notifications,
    Greetings,
    SectionPanels,
    LegacyPageContent,
    // PostOpportunityCampaignDialog,
    WeeklyAvailability,
  },
  computed: {
    ...mapGetters([
      'allTotal',
      'connectionsTotal',
      'profilePercent',
      'profile'
    ]),
  },
})
export default class Home extends Vue {
  @Prop() hasProfile: boolean

  // data
  section = {
    rewards: ''
  }

  // computed
  // mapGetters
  allTotal: number
  connectionsTotal: number
  profilePercent: number
  profile: IUser|null

  now: string = new Date().toISOString()

  nextAvailabilityNotification () {    
    const nextNotification = new Date()
    nextNotification.setDate(nextNotification.getDate() + 1)
    this.$store.dispatch('updateProfile', {
      nextAvailabilityNotificationAt: nextNotification.toISOString()
    })
  }
  // lifecycle hooks
  created () {
    if (!this.connectionsTotal) this.$store.dispatch('listConnections')
    if (!this.allTotal) this.$store.dispatch('listOpportunities')
    // this.$store.commit('showPostOpportunityCampaignDialog')
  }
}
</script>
